import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingHorizontal: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
    position: 'relative',
  },
  title: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 10,
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: 10,
    textAlign: 'center',
    marginBottom: 10,
    color: 'gray',
  },
  section: {
    marginBottom: 10,
  },
  comarcaHeader: {
    fontSize: 12,
    marginBottom: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  table: {
    display: 'flex',
    width: 'auto',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableRowOdd: {
    backgroundColor: '#f5f5f5',
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableColHeader: {
    padding: 5,
    fontWeight: 'bold',
    backgroundColor: '#eee',
    textAlign: 'center',
  },
  tableColHeader1: { width: '35%' },
  tableColHeader2: { width: '32%' },
  tableColHeader3: { width: '33%' },
  tableColHeaderSetor: { width: '60%' },
  tableColHeaderEquipe: { width: '40%' },
  tableCol: {
    padding: 5,
  },
  tableCol1: { width: '35%', textAlign: 'center' },
  tableCol2: { width: '32%', textAlign: 'center' },
  tableCol3: { width: '33%' },
  tableColSetor: { width: '60%', textAlign: 'left' },
  tableColEquipe: { width: '40%' },
  subTable: {
    display: 'flex',
    width: 'auto',
  },
  subTableRow: {
    flexDirection: 'row',
  },
  textMuted: {
    color: 'gray',
    fontSize: 8,
  },
  emptyText: {
    textAlign: 'center',
    color: 'red',
    fontStyle: 'italic',
  },
  fullRow: {
    flexDirection: 'row',
  },
  fullCell: {
    flex: 1,
    padding: 5,
  },
  fullCellGrey: {
    backgroundColor: '#ccc',
  },
  fullCellGrey1: {
    backgroundColor: '#f0f0f0',
  },
});